import styles from "@/components/pages/pricing-a/components/styles/refer-friend.module.scss";
import InviteFriendsMainButton from "@/components/common/invite/invite-friends-main-button";

const ReferFriend = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.text_wrapper}>
        <div className={styles.header_text}>
          Invite Friends and Earn Free Credits
        </div>
        <div className={styles.details_wrapper}>
          <div className={styles.details_text}>
            • Share your unique invite link
          </div>
          <div className={styles.details_text}>
            • Earn 100 credits when your friend signs up and purchases any
            AudioModify plan
          </div>
          <div className={styles.details_text}>
            • Use earned credits to increase limits for song generation and
            custom voices
          </div>
        </div>
      </div>
      <div className={styles.invite_friends_button_wrapper}>
        <InviteFriendsMainButton />
      </div>
    </div>
  );
};

export default ReferFriend;
